module.exports = __webpack_public_path__ + "static/media/4.045f6bf7.png";